import { getSelectedYear } from "../../context/YearContext.js";

export class FilterLink {
  constructor() {
    this.countries = [];
  }

  async request(year = getSelectedYear()) {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          "bk-working": "countries",
          year: year,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      this.receiveJson(data);
      return this;
    } catch (error) {
      console.error("FilterLink request failed:", error);
      throw error;
    }
  }

  receiveJson(data) {
    if (data["bk-result"] === true) {
      this.countries = data.countries || [];
    } else {
      this.countries = [];
    }
  }
}
